<template>
  <img
    v-if="cardIconUrl"
    class="scss-click-effect style-brand-icon-size my-auto me-2"
    :src="require('@/assets/icons/' + cardIconUrl)"
  />
  <i v-else class="bi bi-credit-card-2-front-fill style-icon"></i>
</template>

<script>
import { cardIcon } from "@/common/constant/CardIcon";

export default {
  name: "CardBrandIcon",
  props: {
    cardBrand: String,
  },
  data() {
    return {
      test: "/cards/mastercard.svg",
    };
  },
  computed: {
    cardIconUrl() {
      return cardIcon[this.cardBrand];
    },
  },
};
</script>

<style lang="scss" scoped>
.style-brand-icon-size {
  height: 30px;
  width: 30px;
}

.style-icon {
  font-size: 25px;
  display: flex;
  align-items: center;
  color: $text-light-color;
}
</style>
